<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <v-row no-gutters>
        <v-col cols="12" :md="db.abbr =='instrument'? 10: 6">
          <h1 class="text-h1 mb-2" >{{db.name}}</h1>
        </v-col>
        <v-col cols="12" :md="db.abbr =='instrument'? 2: 6" class="hidden-sm-and-down" justify="end">
          <DbLangOpts v-if="$vuetify.breakpoint.mdAndUp" :abbr="db.abbr" :curLang="db.lang"></DbLangOpts>
        </v-col>
      </v-row>
    </template>

    <template v-slot:leftPanel v-if="$vuetify.breakpoint.mdAndUp">  
      <StatusWidget :statinfo="stat_wdgt" />
    </template>

    <template v-slot:mainPanel>
      <!--Filter Box-->
      <v-card flat class="dbfilterbox lsidebg pl-5 pr-3 pt-2 pb-1 mb-6 d-print-none" max-width="850">
  
        <v-card-title class="px-0 py-0 mb-2">
          <h3 class="text-h6 font-italic pt-1">{{$t('database.filter')}}</h3>
        </v-card-title>
          
        <!--numerical-->
        <v-row class="hidden-xs-only mb-2" no-gutters>
          <v-col cols="12">
            <v-btn-toggle v-model="toggle_range_idx" class="flex-wrap" dense borderless color="link" background-color="transparent" @change="go_search">
              <v-tooltip right color="liiblack lighten-1">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" class="mr-3">mdi-order-numeric-ascending</v-icon>
                </template>
                <span>{{$t('database.legisdb_filter_hint')}}</span>
              </v-tooltip>
              <v-btn 
                v-for="range in num_ranges" :key="range"
                min-width="0"
                text
                class="avaliableindex px-2"
                active-class="currentindex"
              >
                {{range}}
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
                    
        <!--alphabetical-->
        <v-row v-if="db.lang=='EN'" class="hidden-xs-only mb-2 " no-gutters>
          <v-col cols="12">
                
            <v-btn-toggle v-model="toggle_alpha_idx" class="flex-wrap" dense borderless color="link" background-color="transparent" @change="go_search">
              <v-tooltip right color="liiblack lighten-1">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" class="mr-3">mdi-order-alphabetical-ascending</v-icon> 
                </template>
                <span>{{$t('database.legisdb_filter_hint')}}</span>
              </v-tooltip>
              <v-btn 
                v-for="alpha in alphabets" :key="alpha"
                min-width="0"
                text 
                class="avaliableindex px-2"
                active-class="currentindex"
              >
                {{alpha}}
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
                    
        <!--capnum and title-->
        <v-row no-gutters class="my-2">
          <!--cap num-->
          <v-col cols="12" md="3" sm="5" class="my-2">
            <v-text-field
              v-model="srch_capnum"
              class="pr-5 py-0 shrink"
              prepend-icon="mdi-numeric"
              :label="$vuetify.breakpoint.xl || $vuetify.breakpoint.xs?  $i18n.t('database.capno'):$i18n.t('database.cap')"
              hide-details dense clearable
              color="link"
              @keyup.enter="go_search"
            />
          </v-col>
                        
          <!--cap title-->
          <v-col cols="12"  md="6" sm="7" class="my-2">
            <v-text-field
              v-model="srch_captitle"
              class="pl-lg-5 pr-5 py-0 shrink"
              prepend-icon="mdi-text"
              :label="$i18n.t('database.captitle')"
              hide-details dense clearable
              color="link"
              @keyup.enter="go_search"
            />
          </v-col>
                        
          <!--apply filter button-->
          <v-col cols="12" md="3" class="pr-5">
            <v-row no-gutters>
              <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
              <v-btn
                class="link lighten-5 px-8 mt-2 mt-md-1 mb-1"
                outlined
                color="link" 
                @click="go_search"
                max-width="150px"
              >
                <v-icon small class="mr-3">mdi-filter-variant</v-icon>
                {{$t('btntxt.apply')}}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
                
      </v-card>


      <!--Show ALL Found Records-->
      <v-card color="lsidebg" class="elevation-2">
      
        <v-data-table
          :headers="headers"
          :items="files"
          calculate-widths hide-default-footer
          :items-per-page="show_max_dbs.includes(db.abbr) ? 2500 : 100"
          :options.sync="options"
          :server-items-length="totalFiles"
          :loading="loading"
          :page.sync="page"
          @page-count="pageCount = $event"
          class="dbtoc legistoc"
          dense
          :mobile-breakpoint="0"
          :header-props="{'sort-by-text':$i18n.t('database.sortby')}"
          :loading-text="$i18n.t('database.loading')"
          :no-data-text="$i18n.t('error.nodata_warn')"
          :no-results-text="$i18n.t('error.noresult_warn')"
        > <!--:footer-props="{ 'items-per-page-options': [100, 500, 1000, -1], 'items-per-page-text':$t('tbhead.itemperpage') }"-->
            <!--header pagination--> <!--REWRITE THIS. find a way to implement the card pagination-->
                        
          <template v-slot:top="{ pagination, options, updateOptions }">
            <v-data-footer 
              show-current-page show-first-last-page
              :pagination="pagination" 
              :options="options"
              @update:options="updateOptions"
              :items-per-page-options="[100, 500, 1000, 2500]"
              :items-per-page-text="$t('tbhead.itemperpage')"
            />
          </template>

          <!--click on text instead of @click:row.capture="goFile" so text could be highlighted-->
          <template v-slot:item="{item}">
            <tr @click="(event)=>goFile(item, event)" class="sm-row">
              <td>
                <router-link
                  :to="legis_router_loc(item.num)"
                  class="routing"
                  v-html="item.num">
                </router-link>
              </td>
              <td>
                <router-link
                  :to="legis_router_loc(item.num)"
                  :class="item.title.includes('只有英文文本')?'engonly routing':'routing'" 
                  v-html="item.title">
                </router-link>
              </td>
            </tr>
          </template>
        </v-data-table>
                    
        <!--bottom pagination--> 
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-pagination 
              v-model="page"
              color="link lighten-1"
              :length="pageCount" 
              :total-visible="7"
            ></v-pagination>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </template>

    <template v-slot:rightPanel>
      <InfoWidget v-if="db.about" :title="$t('database.aboutdb')" :content='db.about' />
      <InfoWidget v-if="db.cright" :title="$t('database.cright')" :content='db.cright' />
    </template>
  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import api from '@/scripts/api'
  import dbs from '../data/dbs.json'
  import StatusWidget from '../components/StatusWidget'
  import InfoWidget from '../components/InfoWidget'
  import DbLangOpts from '../components/DbLangOpts'
  import datehelper from '@/scripts/datehelper'
  export default {
    name:'database',
    components: {
      ThreeColumn,
      StatusWidget,
      InfoWidget,
      DbLangOpts
    },
    data () {
      return {
        awaitingSearch: false,
        db: {
          id:0,
          abbr:'',
          name:'',
          about:'',
          cright:'',
          cat:''
        },
        cap:{},
        dbs:dbs,
        show_max_dbs: ['instrument'],  // dbs that shows all rows initially
        page:1,
        pageCount:0,
        totalFiles: 0,
        files: [],
        loading: true,
        options: {},
        stat_wdgt:[],
        alphabets: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
        num_ranges: ['1-100', '101-200', '201-300', '301-400', '401-500', '501-600', '601-700', '1001-1100', '1101-1200'],  // no 700-1000 from data perspective
        toggle_alpha_idx: null, // for v-btn-toggle
        toggle_range_idx: null, // for v-btn-toggle
        srch_capnum: null, //filter
        srch_captitle: null, //filter
      }
    },
    watch: {
      'options.page':function(newV,oldV){
        if (Boolean(oldV)&&(newV != oldV)){
          this.get_files()
          window.scrollTo(0,0)
        }
      },
      'options.itemsPerPage':function(newV,oldV){
        if (Boolean(oldV)&&(newV != oldV)){
        this.get_files()
        }
      },
      sort_str(){
          this.options.page = 1
          this.get_files()
      },
      '$route': function(){
          this.db = this.dbs.find(db => db['path'] == this.$route['fullPath'])
          this.options.page = 1
          this.get_files()
      }
    },
    methods:{
      async get_metadata(){
        try {
          const res = await api.get_metalegis(this.db.abbr, this.db.lang)
          this.stat_wdgt.push({label:this.$i18n.t('database.wdg_status_filecount'),val:res['count'], unit:this.$i18n.t('database.wdg_status_fileunit')})
          this.stat_wdgt.push({label:this.$i18n.t('database.wdg_status_updatetime'),val: datehelper.display_date(res['timestamp'])})
        } catch (err){
          console.error(err)
        }
      },
      go_search(){
        this.options.page = 1
        this.get_files()
      },
      async get_files(){
        this.loading = true
        var params = {
          'lang': this.lang,
          'capType': this.db.abbr,
          'capno': this.srch_capnum ? this.srch_capnum.trim() : '',
          'title': this.srch_captitle ? this.srch_captitle.trim() : '',
          'firstLetter': this.alphabets[this.toggle_alpha_idx],
          'numRange': this.num_ranges[this.toggle_range_idx],
          'itemsPerPage': this.options.itemsPerPage,
          'page': this.options.page,
          'sort': this.sort_str
        }
        try {
          const res = await api.get_legisfiles(params)
          this.totalFiles = res['totalfiles']
          this.files = res['files']
        } catch (err){
          console.error(err)
        } finally {
          this.loading = false
        }
      },
      legis_router_loc(num){
        var params = {...this.$route.params, 'cap': num}
        return {name: 'sectiontoc', params: params}
      },
      goFile(item, event){
        let href = this.$router.resolve(this.legis_router_loc(item.num)).href

        var selectedText = getSelection().toString()
        if (selectedText.length == 0 && event.target.tagName !== "A"){
          if (event.ctrlKey){
            // Ctrl + click: open in new tab
            var w = window.open(href, '_blank')
            if (event.shiftKey){
              // Ctrl + Shift + click: open in new tab and focus
              w.focus()
            }
          } else if (event.shiftKey){
            // Shift + click: open in new tab
            window.open(href)
          } else {
            this.$router.push({path: href})
          }
        }
      }
    },
    computed:{
      lang(){
        return this.$route.params.lang
      },
      headers(){ //table header
        return [
          { text: this.$i18n.t('database.cap'), value: 'num' , sortable: true, width:'15%'},
          { text: this.$i18n.t('database.title'), value: 'title', sortable: true}
        ]
      },
      paths(){
        return [
          {text: 'HKLII', disabled: false, href: {name: 'home'}},
          {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
          {text: this.db.name, disabled: true}
        ]
      },
      sort_str(){
        if (!this.options.sortBy || this.options.sortBy.length == 0){
          return ''
        } else {
          // sort one field only
          var s = this.options.sortBy[0]
          if (this.options.sortDesc[0]){
            s = '-' + s
          }
          return s
        }
      }
    },
    beforeMount(){
      // setting up the pagination
      this.db = this.dbs.find(db => db['path'] == this.$route['fullPath'])
    },
    mounted(){
      this.get_metadata()
      this.get_files()
      //window.document.title = this.db.name + ' | HKLII'
    },
    metaInfo(){
      return{
        title: this.db.name,
          meta: [
          {
            name: 'description',
            content: 'Database of ' + this.db.name + ".",
          }
        ],
      }
    },
  }
</script>

<style scoped>
  .dbfilterbox {
    border-left: 3px solid var(--v-l_legis-base) !important;
  }

  .engonly {
    padding-left: 0.5em;
    color: var(--v-darkgrey-lighten2);
    font-style: italic;
  }

  .currentindex {
    font-weight: 700;
    font-size: 0.88em;
  }

  .avaliableindex {
    color: var(--v-link-base) ;
    font-size:  0.88em;
  }

  .sm-row > td:last-child {
    width: 100%;
  }

</style>